export const environment = {
  production: true,
  django: 'https://mitramonitor.solucoesluz.com:7789',
  websocket: 'wss://mitramonitor.solucoesluz.com:7789',
  recaptchaApi: 'https://www.google.com/recaptcha/api.js',
  recaptchaSiteKey: '6LeuW9YqAAAAANQb6ZMylAEFra-GEOsXN2GVYBhY',
};
